import { fetchLogin, fetchLogout, fetchCheckLogin } from '../../network/authRequests'

// initial state
const state = {
	loggedIn: null,
	memberLevel: null,
	available_silver: null,
	account_count: 1
}

// getters
const getters = {

}

// actions
const actions = {
	login({ commit }, { username, password }) {
		return new Promise((resolve, reject) => {
			fetchLogin({ username, password }, (response) => { //not currently doing anything with member returned from login request
				if(response.success){
					commit('setLoggedIn', true)
					resolve() //calls 'then' in Login.vue
				}else{
					reject(response.error)
				}
			},
			errorMessage => {
				reject(errorMessage) //calls 'catch' in Login.vue
			})
		})
	},
	logout({ commit }) {
		return new Promise((resolve, reject) => {
			fetchLogout(response => {
				commit('setLoggedIn', false)
				resolve(response)
			},
			error => {
				reject(error)
			})
		})
	},
	checkLogin(){
		return new Promise((resolve) => {
			fetchCheckLogin(loggedIn => {
				resolve(loggedIn)
			})
		})
	}
}

// mutations
const mutations = {
	setLoggedIn(state, result) {
		state.loggedIn = result
	},
	setMemberLevel(state, result) {
		state.memberLevel = result
	},
	setAvailableSilver(state,result){
	state.available_silver = result
	},
	setAccountCount(state,result){
	state.account_count = result
	}
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
